module.exports = __webpack_public_path__ + "static/media/temp.6778626e.pdf";